<template>
    <div>
        <b-row>
            <b-col>
                <b-button variant="primary" @click="toggle" v-model="toggleStatus" class="float-right">Filtry</b-button>

            </b-col>
        </b-row>

        <div v-show="toggleStatus">
            <b-card-body>
                <b-card-text>
                    <b-row>
                        <b-col>
                            <label>Szukaj</label>
                            <b-form-input v-model="searchTerm" placeholder="Wpisz nazwę kuwertury..." @input="onSearchInput"></b-form-input>
                        </b-col>
                        <b-col>
                            <label>Rodzaj wyświetlania</label>
                            <v-select :options="productVisibilityFilter" v-model="couvertureViewFilter" @input="onFilterChange"></v-select>
                        </b-col>
                    </b-row>
                </b-card-text>
            </b-card-body>
          <hr/>
        </div>
    </div>
</template>
<script>
import dropDownOptionsMixin from '../../mixins/dropDownOptions';

export default {
    name: "DisplayCouvertureFilter",
    mixins: [dropDownOptionsMixin],
    mounted() {
        this.couvertureViewFilter = this.productVisibilityFilter[0]
    },
    props: ["runFilterAction"],
    methods: {
        toggle() {
            this.toggleStatus = !this.toggleStatus;
        },
        onSearchInput() {
            if (this.searchDebounce) {
                clearTimeout(this.searchDebounce);
            }
            this.searchDebounce = setTimeout(() => {
                this.runFilterAction(true);
            }, 500);
        },
        onFilterChange() {
            this.runFilterAction(true);
        }
    },

    data() {
        return {
            toggleStatus: false,
            couvertureViewFilter: {},
            searchTerm: '',
            searchDebounce: null
        }
    }
}
</script>